export default "__VITE_ASSET__C988bKj1__";